import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import {
  salesCreditViewAction,
  salesInvoiceItemsGetAction,
  salesReturnItemsGetAction,
} from "../../../redux/actions/sales-action";
import CreateEditViewSalesCN from "../../../components/sales-section/sales-credit-note/create-edit-view-sales-CN";

const AddSalesCreditNote = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();

  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  //
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(salesCreditViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "invoice") {
      setLoading(true);
      dispatch(salesInvoiceItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "return") {
      setLoading(true);
      dispatch(salesReturnItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const isNew = searchParams.has("new");

  const prefix = searchParams.get("type") || "soit";
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title={`${isClone ? "Clone" : "Add"} Sales Credit Note`}
        >
          <CreateEditViewSalesCN
            clickedplus={isNew}
            isClone={isClone}
            page="add"
            payto={
              isClone
                ? orderDetail?.orderData?.sct_pay_to_address
                : vendorDetails?.[`${prefix}_pay_to_address`]
            }
            shipto={
              isClone
                ? orderDetail?.orderData?.sct_ship_to_address
                : vendorDetails?.[`${prefix}_ship_to_address`]
            }
            pageType="credit note"
            type={type}
            orderDetail={orderDetail?.itemData}
            vendorDetails={
              isClone
                ? [orderDetail?.orderData]
                : [
                    {
                      ...vendorDetails,
                      sct_sub_total: orderData?.sub_total,
                      sct_total_gst: orderData?.total_tax,
                      sct_total_discount: orderData?.total_discount,
                      sct_total_amount: orderData?.total_amount,
                      sct_round_off_value: orderData?.round_off_value,
                      sct_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                      sct_tcs_or_tds_percentage_id:
                        orderData?.tcs_or_tds_percentage_id,
                      sct_tcs_or_tds_percentage:
                        orderData?.tcs_or_tds_percentage,
                      sct_tds_tcs_type: orderData?.tcs_or_tds_type,
                      sct_is_invoice_dis_percentage:
                        orderData?.is_invoice_dis_percentage ?? true,
                      sct_invoice_discount: orderData?.invoice_discount ?? 0,
                      sct_invoice_discount_percentage:
                        orderData?.invoice_discount_percentage ?? 0,
                    },
                  ]
            }
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddSalesCreditNote;
